// 设备管理
export default {
    permission: 'разрешение',
    details: 'Подробности',
    serialNumber: 'серийный номер',
    devicwarrantyPeriodeID: 'гарантийный срок',
    totalFlightTime: 'общее время полета',
    numberFlights: 'количество рейсов',
    activationTime: 'Время активации',
    deviceID: 'идентификатор устройства',
    equipmentType: 'Тип оборудования',
    pleaseChoose: 'пожалуйста, выберите',
    drone: 'дрон',
    RTK: 'РТК',
    weatherStation: 'метеостанция',
    editDevice: 'изменить устройство',
    addDevice: 'Добавить устройство',
    snCode: 'Серийный код',
    factoryTime: 'Заводское время',
    deviceName: 'имя устройства',
    uploadImage: 'загрузить изображение',
    deviceDetails: 'Сведения об устройстве',
    permissionSettings: 'Настройки разрешений',
    deviceNameNoreapt: 'Имя устройства уже существует и не может быть повторено',
    required: 'Необходимый',
    all: 'все',
    rtk: 'ртк',
    totalEquipment: 'общее оборудование',
    deviceManagement: 'Управление устройствами',
    enterSnCode: 'Пожалуйста, введите SN-код',
    isdelDevice: 'После удаления устройства отношения привязки устройства будут удалены. Удалить устройство?',
    delDevice: 'удалить устройство',
    delSuccess: 'успешно удален',
    deviceStatus: 'состояние устройства',
    networkStatus: 'статус сети',
    entryTime: 'Время входа',
    permissionStatus: 'статус разрешения',
    versionNumber: 'номер версии',
    user: 'Пользователь',
    operate: 'действовать',
    shared: 'общий',
    isShared: 'общий',
    notShared: 'не поделился',
    offline: 'не в сети',
    online: 'онлайн',
    test: 'тестовое задание',
    pendingSale: 'в ожидании продажи',
    using: 'С использованием',
    inMaintenance: 'в обеспечении',
    disable: 'Запрещать',
    scrapped: 'списан',
    department: 'отделение',
    addDepartment: 'Добавить отдел',
    nameQuery: 'запрос имени',
    name: 'запрос имени',
    mobilePhone: 'мобильный телефон',
    license: 'лицензия',
    licenseType: 'Тип лицензии',
    isName: 'имя',
    deptIsRepeat:'Этот отдел уже существует! Пожалуйста, выберите другой отдел',
    selcetHasUserDept:'Выберите отдел с пользователями',
    cloudTime:'上云时间',
    operationUser:'操作用户',
    authorizedTime:'授权时间',
    authorizationDeadline:'授权截止时间',
    cloudDevice:'上云设备',
    equipmentModel:'设备型号',
    syDeviceNum:'组织授权上云设备数量',
    admin: 'администратор',
    tips_AHTH: 'Администраторы имеют самые высокие разрешения на всех устройствах.',
}
